export const faqData = [
  {
    id: 1,
    title: "DESIGN & INSTALLATION",
    content: [
      {
        id: 1,
        title: "I would love to see what Classy Kitchen and Bath can do for me. How do I get started?",
        contents:
          "The quickest way to get started is to click on <a href='/get-in-touch'> “Start Your FREE CONSULTATION” </a> , and a member of our Classy Kitchen and Bath team will promptly respond to you. You can also call us at 480-933-0355 or visit the showroom nearest you.",
      },
      {
        id: 2,
        title: "How much experience do your designers have?",
        contents:
          "All our Classy Kitchen and Bath designers are trained extensively in kitchen/ bath and space design. They will listen to your vision, learn about your wants and needs and collaborate with you to create the perfect custom design solution for your kitchen or bathroom.",
      },
      {
        id: 3,
        title: "What happens when my project is ready to be installed?",
        contents:
          "Once the contract is completed the designs will be evaluated by our pre-engineering team to ensure all pertinent information has been provided and is in order. Once pre-engineering approves the project it will move directly into production where our craftspeople will create your custom cabinetry and countertops. We will reach out to you about five days prior to your installation to confirm the date.",
      },
      {
        id: 4,
        title: "Do you use sub-contractors for installation?",
        contents: "No. All Classy Kitchen & Bath installers are employees of the company and we have decades of experience within our installation team. Each job is led by an installer that has successfully completed our training program to qualify them for the installation he/she is performing. In addition, a project coordinator will be assigned to your job to help ensure the installation goes smoothly and we keep to the timeline expectations set with you.",
      },
    ],
  },
  {
    id: 1,
    title: "COMPANY GENERAL",
    content: [
      {
        id: 1,
        title: "Why should I go with Classy Kitchen & Bath?",
        contents:
          `There are many reasons why Classy Kitchen & Bath is a great company to work with, including: 
          <ul class='list'> 
            <li>Our sister company, Classy Closets was established in 1983. Over the 35+ years, we have had kitchens and baths included in our product line. Our kitchen and bath line has been so popular that the natural thing to do was to expand our company and create Classy Kitchen and Bath.</li>
            <li>We have an A+ rating and Accredited Business with the Better Business Bureau since 1986. </li>
            <li>We have our production facilities using state-of-the-art computerized equipment (saws, drills, and edgebanders).</li>
            <li>Our products are truly customized: While other companies may assemble modular units together to fit within the customer’s space, we truly build wall to wall. We are equipped to make final cuts on-site to ensure a solid fit, and we also provide custom widths, heights, and depths.</li>
            <li>We provide a greater selection of materials. Something we take pride in as a company is offering an expansive selection. We are sure to have materials and finishes that meet your wants and needs. Choose from a wide selection of materials, finishes, designs, and accessories with the help of your trained designer.</li>
            <li>We offer a limited lifetime guarantee.</li>
          </ul>
          `,
      },
    ],
  },
  {
    id: 1,
    title: "COST",
    content: [
      {
        id: 1,
        title: "Can you let me know how much my project will cost?",
        contents:
          "Every project is unique and based on the specific space and needs of our customers. While it is difficult to provide realistic price estimates over the phone, we can give you a good price expectation after a short in-home consultation; We may also be able to give you a price estimate, depending on the complexity of the project if you visit one of our showrooms. Our designers are most qualified to answer these questions. If you call in advance of your visit, we will make every attempt to have a designer available to meet with you.",
      },
      {
        id: 2,
        title: "Do you manufacture your products?",
        contents: "Yes, Classy Closets is a direct manufacturer and has full control of the quality of our product from start to finish. Unlike many others in our industry, we do not source pre-fabricated parts from large producers thousands of miles away. By controlling our manufacturing, we also have great flexibility in design and can react quickly should any adjustments be needed.",
      },
      {
        id: 3,
        title: "Do you use particleboard or pressboard?",
        contents: "Yes, we offer over 40 beautiful real wood finishes as well as providing our customers with the opportunity for a custom stain or paint finish.",
      },
      {
        id: 4,
        title: "Do you have real wood options?",
        contents: "The material substrate we use (pressboard, MDF, or plywood) is determined by the type of laminate or veneer that is being adhered to it. Melamine, the primary laminate used for closets and furniture, requires a very smooth and stable surface which makes particleboard the best substrate for this material. Pressboard is available in various grades based on density. We use only the highest quality industrial grade pressboard compared to the standard commercial grade used by most others. Wood veneers are either adhered to plywood or MDF (medium-density fiberboard) substrate. We use a top-quality calibrated core plywood substrate for our standard wood veneers.",
      },
      {
        id: 5,
        title: "What is wood veneer? When is veneer used vs. solid wood?",
        contents: "Veneer refers to thin slices of wood that are glued to a substrate core to produce flat panels with a consistent grain pattern. Planks of solid wood wide enough for cabinet cases are not available in most hardwood species and also tend to warp and curl over time. Veneers are used for flat panel surfaces such as cabinet cases and closets. Solid woods are used for decorative fronts such as raised panel and shaker styles as well as moldings.",
      },
      {
        id: 6,
        title: "Do your products fade or darken over time?",
        contents: "Some materials will change color with aging while others will remain consistent. Laminates such as melamine will never change in color even when exposed to sunlight. Real woods will age over time and typically become darker. Wood is a natural product and the species and finish could affect the degree of aging.",
      },
    ],
  },
  {
    id: 1,
    title: "PRODUCT MAINTENANCE",
    content: [
      {
        id: 1,
        title: "How do I adjust a shelf?",
        contents:
          "Shelves can be easily adjusted. Follow the instructions below for the type of shelf you are moving. Adjustable shelving on pins: For closets, garage cabinets and furniture shelves behind doors simply remove the shelf by lifting one end about 2 inches. Then pull the shelf out, remove all four shelf pins and re-insert them at the desired height. Replace the shelf. (pliers may help in removing shelf pins)Fixed shelving: Unlock the Knock Down (KD) fittings with a Phillips screwdriver from the bottom or underneath. Then, lightly tap underneath the shelf until it comes free of the fasteners and then pull the shelf out.",
      },
      {
        id: 2,
        title: "How do I clean my system?",
        contents:
          "Melamine and high-pressure laminate systems clean easily with a damp cloth and some glass cleaner or 409. To remove tough spots such as glue or ink use a small amount of mineral spirits or Goo Gone. Do not use an abrasive cleaner on laminate products. Endust is a great cleaner for wood products. For more information go to our care instructions.",
      },
    ],
  },
  {
    id: 1,
    title: "ENVIRONMENTAL AWARENESS",
    content: [
      {
        id: 1,
        title: "Do you consider yourself an environmentally conscious company?",
        contents:
          "Yes, we do. Classy Companies uses over 95% pre-consumer recycled materials in its products. Our Green Line is a 100% “green” product that is harvested from sustainable forests and qualifies for LEED. Our Green Building Division is headed by an employee who is a LEED Accredited Professional.",
      },
    ],
  },
  {
    id: 1,
    title: "SERVICE & WARRANTY",
    content: [
      {
        id: 1,
        title: "What if I need a repair or service in the future?",
        contents:
          "Just contact us, and we are happy to help. Our customer service department can be reached via our online contact request form found on our website. Both phone calls and online submittals are promptly responded to.",
      },
      {
        id: 2,
        title: "What is your warranty?",
        contents:
          "We are fully committed to the quality of both our product and installation and offer a lifetime limited warranty on our materials and workmanship as long as you live in the home.",
      },
    ],
  },
];
